import React from 'react';
import { RouteComponentProps } from 'react-router';

import { Permissions } from '@checkit/react-components';

import { BulkImportCheckpoints } from './checkpoints/bulk/BulkImportCheckpoints';
import CheckpointList from './checkpoints/list/CheckpointList';
import { NewCheckpoint } from './checkpoints/new/NewCheckpoint';
import UpdateCheckpoint from './checkpoints/update/UpdateCheckpoint';
import CheckpointTypeList from './checkpointTypes/list/CheckpointTypeList';
import { NewCheckpointType } from './checkpointTypes/new/NewCheckpointType';
import { UpdateCheckpointType } from './checkpointTypes/update/UpdateCheckpointType';
import { Dashboard } from './dashboard/Dashboard';
import { LibrariesList } from './libraries/list/LibrariesList';
import { NewLibrary } from './libraries/new/NewLibrary';
import { UpdateLibrary } from './libraries/update/UpdateLibrary';
import { UserDefinedRolesList } from './userDefinedRoles/list/UserDefinedRoleList';
import { NewUserDefinedRole } from './userDefinedRoles/new/NewUserDefinedRole';
import UpdateUserDefinedRole from './userDefinedRoles/update/UpdateUserDefinedRole';

export interface AppRoute {
  path: string;
  exact?: boolean;
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  permissions?: Permissions;
}

export type AppRoutes = AppRoute[];

const checkpointsPermissions: Permissions = {
  permittedRoles: ['administrator'],
  requiredFeatures: ['QR-SCANNING']
};

const librariesPermissions: Permissions = {
  permittedRoles: ['safetyManager'],
  requiredFeatures: ['LIBRARIES']
};

const userDefinedRolesPermissions: Permissions = {
  permittedRoles: ['administrator'],
  requiredFeatures: ['USER-DEFINED-ROLES']
};

export const routes: AppRoutes = [
  {
    component: Dashboard,
    path: '/'
  },
  {
    component: BulkImportCheckpoints,
    path: '/checkpoints/bulkImport',
    permissions: checkpointsPermissions
  },
  {
    component: CheckpointTypeList,
    path: '/checkpointtypes',
    permissions: checkpointsPermissions
  },
  {
    component: CheckpointList,
    path: '/checkpoints',
    permissions: checkpointsPermissions
  },
  {
    component: NewCheckpointType,
    path: '/checkpointtypes/new',
    permissions: checkpointsPermissions
  },
  {
    component: UpdateCheckpointType,
    path: '/checkpointtypes/:checkpointTypeCode',
    permissions: checkpointsPermissions
  },
  {
    component: NewCheckpoint,
    path: '/checkpoints/new',
    permissions: checkpointsPermissions
  },
  {
    component: UpdateCheckpoint,
    path: '/checkpoints/:checkpointCode',
    permissions: checkpointsPermissions
  },
  {
    component: LibrariesList,
    path: '/libraries',
    permissions: librariesPermissions
  },
  {
    component: NewLibrary,
    path: '/libraries/new',
    permissions: librariesPermissions
  },
  {
    component: UpdateLibrary,
    path: '/libraries/:libraryCode',
    permissions: librariesPermissions
  },
  {
    component: UserDefinedRolesList,
    path: '/user-defined-roles',
    permissions: userDefinedRolesPermissions
  },
  {
    component: NewUserDefinedRole,
    path: '/user-defined-roles/new',
    permissions: userDefinedRolesPermissions
  },
  {
    component: UpdateUserDefinedRole,
    path: '/user-defined-roles/:userDefinedRoleCode',
    permissions: userDefinedRolesPermissions
  }
];
